<script setup>
import {ref, reactive, onBeforeMount} from "vue"
import router from "@/router/index.js";
import {
  addBizCategory,
  detailBizCategory,
  updateBizCategory
} from "@/api/bizCategory/bizCategory.js";
import {getRoute} from "@/hooks/getRoute.js";

/*获取路由信息，带参则为修改*/
const {route} = getRoute()
// 父级类目名称
const fatherBizCategoryName = ref(null)
// 是否仅读
const readOnly = ref(false)
onBeforeMount(async () => {
  if (!route.query.bizCategoryId && !route.query.fatherBizCategoryId) {
    ElMessage.error("类目信息获取失败")
    loading.value = true
  } else {
    readOnly.value = Number(route.query.readOnly) !== 0
    if (route.query.fatherBizCategoryId) {
      ruleForm.parentId = route.query.fatherBizCategoryId
      await getFatherDetail()
    } else {
      ruleForm.bizCategoryId = route.query.bizCategoryId
      // 获取父类目树列表，进行sort设置
      await getDetail()
    }
  }
})
// 获取子类类目信息
const getDetail = async () => {
  try {
    loading.value = true
    const res = await detailBizCategory(ruleForm.bizCategoryId)
    ruleForm.parentId = res.parentId
    ruleForm.bizCategoryId = res.bizCategoryId
    ruleForm.bizCategoryName = res.bizCategoryName
    ruleForm.bizCategoryNameEn = res.bizCategoryNameEn
    ruleForm.state = res.state
    ruleForm.sort = res.sort
    const fatherRes = await detailBizCategory(ruleForm.parentId)
    fatherBizCategoryName.value = fatherRes.bizCategoryName
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = true
  }
}
// 获取父类类目信息
const getFatherDetail = async () => {
  try {
    loading.value = true
    const res = await detailBizCategory(ruleForm.parentId)
    fatherBizCategoryName.value = res.bizCategoryName
    ruleForm.sort = res.children.length + 1
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = true
  }
}

// 表单加载状态
const loading = ref(false);

// 表单组件锚点
const ruleFormRef = ref()

// 表单信息
const ruleForm = reactive({
  parentId: null,
  bizCategoryId: null,
  bizCategoryName: null,
  bizCategoryNameEn: null,
  state: "ON_SHELF",
  sort: 99
})
// 类目名称校验规则
const checkCategoryName = (rule, value, callback) => {
  if (!ruleForm.bizCategoryName) return callback(new Error("请输入类目名称（中文）"))
  if (!ruleForm.bizCategoryNameEn) return callback(new Error("请输入类目名称（English）"))
  return callback()
}
// 表单校验规则
const rules = reactive({
  bizCategoryName: [
    {required: true, validator: checkCategoryName, trigger: "blur"}
  ]
})
// 取消新增
const cancelAdd = () => {
  router.back()
}
// 保存校验表单
const submit = async () => {
  loading.value = true
  await ruleFormRef.value.validate(async (valid) => {
    if (valid) {
      try {
        let param = {
          ...ruleForm
        }
        if (route.query.readOnly && route.query.bizCategoryId) {
          await updateBizCategory(param)
        } else {
          await addBizCategory(param)
        }
        ElMessage.success("新增成功")
        router.push("/listItemBizCategory")
      } catch (e) {
        loading.value = false
      }
    } else {
      ElMessage.error("请根据提示修改表单信息")
      loading.value = false
    }
  })
}

/*中英文切换输入框相关Tab*/
// 类目名称tab
const bizCategoryNameTab = ref("zh")
</script>

<template>
  <el-form
      ref="ruleFormRef"
      :model="ruleForm"
      :rules="rules"
      label-width="auto"
      class="demo-ruleForm container_form mg_b_3"
      size="large"
      v-loading="loading">
    <el-form-item label="类目类型：" prop="">
      二级类目
    </el-form-item>
    <el-form-item label="父级：" prop="">
      <div class="mg_r_2">
        {{ fatherBizCategoryName ? fatherBizCategoryName : '父级名称' }}
      </div>
      <div class="tips_default">父类，即新增类目的上级类目</div>
    </el-form-item>
    <el-form-item label="类目名称：" prop="bizCategoryName">
      <el-tabs
          v-model="bizCategoryNameTab"
          type="card"
          class="demo-tabs"
      >
        <el-tab-pane label="中文" name="zh">
          <el-input :disabled="readOnly" maxlength="50" show-word-limit style="width: 350px" v-model="ruleForm.bizCategoryName" placeholder="请输入类目名称" />
        </el-tab-pane>
        <el-tab-pane label="English" name="en">
          <el-input :disabled="readOnly" maxlength="150" show-word-limit style="width: 350px" v-model="ruleForm.bizCategoryNameEn" placeholder="Please enter the category name" />
        </el-tab-pane>
      </el-tabs>
    </el-form-item>
    <v-row class="mg_t_2">
      <v-col cols="4">
        <v-row>
          <v-col cols="6">
            <v-btn @click="cancelAdd">取消</v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn color="primary" @click="submit" :disabled="readOnly">保存</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </el-form>
</template>

<style lang="scss" scoped>
.btn_check {
  width: 28px;
  height: 28px;
  border-radius: 36px;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  z-index: 100;
  background-color:#4caf50;
  display: flex;
  justify-content: center;
  align-items: center;
}

::marker {
  content: none;
}
</style>
